import React from 'react';
import { Link } from 'react-router-dom';
import { Store, ShoppingCart, DollarSign, Clock } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
export function TeamStoresSection() {
  return <section className="py-20 bg-gray-50" data-id="element-267">
      <Container data-id="element-268">
        <div className="flex flex-col lg:flex-row-reverse items-center gap-12" data-id="element-269">
          <div className="lg:w-1/2" data-id="element-270">
            <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-6 text-gray-900" data-id="element-271">
              Team Stores That Help Fans Order and Teams Raise Funds
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mb-6" data-id="element-272"></div>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-273">
              A team store is a dedicated webpage where one team's fan items are
              grouped together. Players, parents, fans, and families can shop
              that team's gear online year round OR during an ordering window —
              and your organization can add a rebate to raise funds. Whether you
              are an individual team or club with different teams and
              team-specific designs, we can set up a flexible store for you.
            </p>

            <div className="space-y-6 mb-10" data-id="element-274">
              <div className="flex items-start" data-id="element-275">
                <div className="bg-red-50 p-3 rounded-full text-pts-red mr-4 mt-1" data-id="element-276">
                  <ShoppingCart className="h-6 w-6" data-id="element-277" />
                </div>
                <div data-id="element-278">
                  <h4 className="font-oswald text-xl font-bold uppercase text-gray-900" data-id="element-279">
                    Custom Gear for Fans & Families
                  </h4>
                  <p className="text-gray-600" data-id="element-280">
                    Give players, parents, fans, and supporters a team-specific
                    webpage where they can shop approved gear.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-281">
                <div className="bg-red-50 p-3 rounded-full text-pts-red mr-4 mt-1" data-id="element-282">
                  <Clock className="h-6 w-6" data-id="element-283" />
                </div>
                <div data-id="element-284">
                  <h4 className="font-oswald text-xl font-bold uppercase text-gray-900" data-id="element-285">
                    Flexible Online Store Setup
                  </h4>
                  <p className="text-gray-600" data-id="element-286">
                    Stores can run year round or during a set ordering window,
                    depending on the program.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-287">
                <div className="bg-red-50 p-3 rounded-full text-pts-red mr-4 mt-1" data-id="element-288">
                  <DollarSign className="h-6 w-6" data-id="element-289" />
                </div>
                <div data-id="element-290">
                  <h4 className="font-oswald text-xl font-bold uppercase text-gray-900" data-id="element-291">
                    Rebate / Fundraising Options
                  </h4>
                  <p className="text-gray-600" data-id="element-292">
                    Your organization can add a rebate structure to raise funds
                    from eligible store sales.
                  </p>
                </div>
              </div>
            </div>

            <Link to="/team-stores" className="inline-flex items-center bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded font-bold uppercase tracking-wide text-lg transition-colors" data-id="element-293">
              Learn About Team Stores
            </Link>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-294">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="relative" data-id="element-295">
              <div className="absolute -inset-4 bg-pts-red/10 rounded-2xl transform -rotate-3 z-0" data-id="element-296"></div>
              <img src="https://cdn.magicpatterns.com/uploads/8wCLodfzo8HCgLPLTk82Za/team-stores.png" alt="Team-specific online product collection with custom gear and apparel" className="relative z-10 w-full h-auto rounded-xl shadow-xl border border-gray-200" data-id="element-297" />
            </motion.div>
          </div>
        </div>
      </Container>
    </section>;
}